import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { reviews } from '../data/testimonials';
export function Testimonials() {
  return <section className="border-y border-primary/30 bg-surface py-16 sm:py-20" aria-labelledby="reviews-title" data-id="element-214" data-mp="3fycqdmmec5as">
      <div className="mx-auto max-w-6xl px-4" data-id="element-215" data-mp="3b01g5as6vss1">
        <SectionHeading id="reviews-title" data-id="element-216" data-mp="36yppr31hr3is">Testimonials from <span className="text-accent" data-id="element-217" data-mp="370k9ie110pla">Battery & Energy Storage Professionals</span></SectionHeading>
        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-218" data-mp="31ybhbjvz9rk8">
          {reviews.map(([initials, name, role, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.15
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col rounded-2xl border border-primary/50 bg-background p-6 shadow-lg shadow-black/30" data-id="element-219" data-mp="2x2w32qu25tna" data-mpi={index}>
              <div className="flex text-accent" aria-label="5 out of 5 stars" data-id="element-220" data-mp="m5b2jjdzrkfp">
                {Array.from({
              length: 5
            }, (_, star) => <StarIcon key={star} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-221" data-mp="79v8vfhbpqju" />)}
              </div>
              <blockquote className="mt-4 flex-1 leading-relaxed text-muted" data-id="element-222" data-mp="c8oiuxxeizf9">“{quote}”</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-primary/15 pt-4" data-id="element-223" data-mp="zysf2k89fww8">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-primary/40 bg-surface text-sm font-extrabold text-primary" data-id="element-224" data-mp="14xdc6as7u0gg">
                  {initials}
                </span>
                <span data-id="element-225" data-mp="1ivk316yqz06m">
                  <b className="block text-sm text-foreground" data-id="element-226" data-mp="1iu9019d4lwgk">{name}</b>
                  <small className="text-xs text-muted" data-id="element-227" data-mp="1nlqs17x68mpe">{role}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}